<p class='text-capitalize font-16 d-flex justify-content-between'>
  <img
    *ngIf="this.testService.getTestResultColor(testData.calculationResult) === 'High'"
    alt='high' src='../../../assets/testicons/high.png' height='24' width='46'/>
  <img
    *ngIf="this.testService.getTestResultColor(testData.calculationResult) === 'Medium'"
    alt='medium' src='../../../assets/testicons/medium.png' height='24' width='46'/>
  <img
    *ngIf="this.testService.getTestResultColor(testData.calculationResult) === 'Low'"
    alt='low' src='../../../assets/testicons/low.png' height='24' width='46'/>
</p>
